<template>
  <div class="useAddress">
    <el-radio-group @change='radioChange' :style="radio==='1' ? '' : 'marginBottom: 20px;'" v-model="radio">
      <el-radio-button label="1">全国</el-radio-button>
      <el-radio-button label="2" v-show='!disHaohuaAbleRadio && !disDaijiaAbleRadio'>限定城市</el-radio-button>
      <el-radio-button label="3" v-show="!disAbleRadio && !disHaohuaAbleRadio  && !disDaijiaAbleRadio">限定位置</el-radio-button>
    </el-radio-group>
    <el-form v-if="allDisAble" label-position="right" label-width="70px">
      <el-form-item label="选择城市" v-if="cityAble" v-model="formData.citys">
        <select-citys :defaultCitys='formData.citys' :callback="selectCity" />
      </el-form-item>
      <section v-if="addressAble">
        <el-form-item label="限制方式">
          <el-select
              v-model="limitValue"
              :popper-append-to-body="false"
            >
              <el-option
                v-for="(item) in limitOptions"
                :key="item.name + item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="出发地" v-if="startAble" >
          <div class="addressList">
            <p class='addressItem' v-for="(item, index) in formData.addresssStart" :key="index + 'addresssStart'">
              {{item.text}}
              <i  @click="delectAddressItem(index, 'addresssStart')" class="el-icon-close"></i>
            </p>
          </div>
          <el-button type="primary" plain @click="addBtn('addresssStart')">添加地点</el-button>
        </el-form-item>
        <el-form-item label="目的地" v-if="endAble" >
          <div class="addressList">
            <p class='addressItem' v-for="(item, index) in formData.addresssEnd" :key="index + 'addresssEnd'">
              {{item.text}}
              <i  @click="delectAddressItem(index, 'addresssEnd')" class="el-icon-close"></i>
            </p>
          </div>
          <el-button type="primary" plain @click="addBtn('addresssEnd')">添加地点</el-button>
        </el-form-item>
      </section>
    </el-form>
    <select-address @historyCallback='historyCallback' :disAbleData='disAbleData' :dialogFormVisible.sync="dialogFormVisible"  :callback="selectAddressCal" />
  </div>
</template>
<script>
import SelectCitys from './SelectCitys.vue'
import SelectAddress from './SelectAddress.vue'
import { loadScript } from 'Plugins/helper'
import {mapActions, mapState} from 'vuex'
export default {
  name: 'UseAddress',
  computed: {
    startAble: function (params) {
      return this.limitValue !== '3'
    },
    endAble: function (params) {
      return this.limitValue !== '2'
    },
    ...mapState('fenceData', [
      'createSuc'
    ]),
    ...mapState('purchase', {
      defaultData: 'orderInfo',
      productId: 'productId'
    })
  },
  watch: {
    radio: function (params) {
      this.radioChange(params)
    },
    selectFlag: function (params) {
      this.disAbleData.selectFlag = params
    },
    createSuc: function (params) {
      if (params.id) {
        this.disAbleData[this.selectFlag] = this.disAbleData[this.selectFlag].concat([params.id])
      }
    },
    defaultData: function (params) {
      this.defaultDataHuitian()
    },
    productId: function (params) {
      this.handleProductId(this.productId)
    }
  },
  data () {
    return {
      radio: '1',
      allDisAble: false,
      cityAble: false,
      addressAble: false,
      dialogFormVisible: false,
      formData: {
        citys: [],
        addresssStart: [],
        addresssEnd: []
      },
      disAbleData: {
        addresssStart: [],
        addresssEnd: [],
        selectFlag: 'addresssStart'
      },
      disAbleRadio: false,
      disHaohuaAbleRadio: false,
      disDaijiaAbleRadio: false,
      selectFlag: 'addresssStart',
      limitValue: '1',
      limitOptions: [{
        id: '1',
        name: '限制出发地和目的地'
      }, {
        id: '2',
        name: '仅限制出发地'
      }, {
        id: '3',
        name: '仅限制目的地'
      }, {
        id: '4',
        name: '限制出发地或目的地'
      }]
    }
  },
  props: ['callback'],
  mounted () {
    // 回填数据
    // this.defaultDataHuitian()
    /* 腾讯地图api */
    window.init = function () {
    }
    loadScript('//map.qq.com/api/js?v=2.exp&key=S2XBZ-EFUHV-ZXNPO-UB7MU-DACB2-5KFTP&callback=init')

    this.callBackData()

    this.getCityList() // 获取城市列表 供组件选择
  },
  updated () {
    this.callBackData()
  },
  methods: {
    callBackData () {
      let city
      let cityArr = []
      this.formData.citys.map((v, i) => {
        // cityArr.push(v.id)
        cityArr.push(v)
      })
      city = cityArr.join(',') || 0
      let fenceType = this.limitValue
      if (this.radio !== '3') {
        fenceType = 0
      }

      let startId = []
      this.formData.addresssStart.map((v, i) => {
        startId.push(v.fenceId)
      })

      let endId = []
      this.formData.addresssEnd.map((v, i) => {
        endId.push(v.fenceId)
      })

      let data = {
        addressRadio: this.radio,
        city,
        fenceType,
        startFence: startId.join(','),
        // startFenceList: [...this.formData.addresssStart],
        endFence: endId.join(',')
        // endFenceList: [...this.formData.addresssEnd]
      }
      this.callback(data)
    },
    handleProductId (productId) {
      // 如果选择的券类型 不为 代驾，用户又改为代驾，则需要禁用限定城市与限定位置，以及将使用地改为全国
      if (productId === 120) {
        this.disAbleRadio = true
        this.radio = '1'
      } else {
        this.disAbleRadio = false
      }
      //选择通用券的时候要禁用限定城市与限定位置，以及将使用地改为全国
      if (productId === 20) {
        this.disAbleRadio = true
        this.radio = '1'
      } else {
        this.disAbleRadio = false
      }
      // 如果选择的券类型 为 豪华车 则需要禁用限定城市与限定位置
      if (productId === 181) {
        this.disHaohuaAbleRadio = true
        this.radio = '1'
      } else {
        this.disHaohuaAbleRadio = false
      }
      // 如果选择的券类型 为 代驾 则需要禁用限定城市与限定位置
      if (productId === 120) {
        this.disDaijiaAbleRadio = true
        this.radio = '1'
      } else {
        this.disDaijiaAbleRadio = false
      }
    },
    defaultDataHuitian: function (params) {
      // props数据 回填到组件
      let defaultData = this.defaultData
      // console.log('defaultData', defaultData)
      if (defaultData) {
        let start = []
        if (defaultData.startFenceList && defaultData.startFenceList.length > 0) {
          defaultData.startFenceList.map((v, i) => {
            let data = {...v.fenceJson, fenceId: v.couponFence.id}
            start.push(data)
          })
        }
        let end = []
        if (defaultData.endFenceList && defaultData.endFenceList.length > 0) {
          defaultData.endFenceList.map((v, i) => {
            let data = {...v.fenceJson, fenceId: v.couponFence.id}
            end.push(data)
          })
        }
        this.radio = defaultData.addressRadio ? (defaultData.addressRadio + '') : '1'
        this.limitValue = defaultData.fenceType ? (defaultData.fenceType + '') : '1'
        this.handleProductId(defaultData.productId)
        this.formData = {
          citys: defaultData.cityIdList ? defaultData.cityIdList.split(',') : [],
          addresssStart: start,
          addresssEnd: end
        }
      }
    },
    selectCity (v) {
      this.formData.citys = [...v]
    },
    selectAddressCal (v) {
      this.formData[this.selectFlag].push(v)
    },
    historyCallback (data) {
      let arr = []
      let arr2 = []
      // console.log('historyCallback-->data', data)
      data.map((v, i) => {
        arr.push({...v.fenceJson, fenceId: v.id})
        // arr.push(v.id)
        arr2.push(v.id)
      })
      this.formData[this.selectFlag] = this.formData[this.selectFlag].concat(arr)
      this.disAbleData[this.selectFlag] = this.disAbleData[this.selectFlag].concat(arr2)
    },
    radioChange (v) {
      this.allDisAble = v !== '1'
      this.cityAble = v === '2'
      this.addressAble = v === '3'
    },
    delectAddressItem (i, v) {
      this.formData[v].splice(i, 1)
      this.disAbleData[v].splice(i, 1)
      this.$nextTick(() => {
        this.disAbleData = {...this.disAbleData} // 为了让子组件重新渲染
      })
    },
    addBtn (v) {
      this.dialogFormVisible = true
      this.selectFlag = v
    },
    ...mapActions('selectAddress', [
      'getCityList'
    ])
  },
  components: {
    SelectCitys,
    SelectAddress
  }
}

</script>
<style lang='stylus'>
  $lan = #3468ff
  .el-form-item .useAddress  .el-form-item {
    margin-bottom: 12px;
  }
  .useAddress .el-radio-button__orig-radio:checked+.el-radio-button__inner {
    color: $lan;
    background: #fff;
    border-color: $lan;
    box-shadow: -1px 0 0 0 $lan;
  }
  .useAddress .el-radio-button__inner:hover {
    color: $lan;
  }
  .useAddress .el-radio-button:last-child .el-radio-button__inner,
  .useAddress .el-radio-button:first-child .el-radio-button__inner {
    border-radius: 0;
  }
  .useAddress .el-select .el-input__inner:focus {
    border-color: $lan;
  }
  .useAddress .el-select-dropdown.is-multiple .el-select-dropdown__item.selected {
    color: $lan;
  }
  .useAddress .el-select-dropdown__item.selected {
    color: $lan;
  }
  .useAddress .el-button--primary.is-plain {
    border: 2px solid $lan;
    background: #fff;
    color: $lan;
    font-weight: 500;
  }
  .el-checkbox.is-bordered.is-checked {
    border-color: $lan;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: $lan;
    border-color: $lan;
  }
  .useAddress .el-checkbox.is-bordered.is-disabled {
    border-color: #ebeef5;
  }
  .el-checkbox__input.is-checked+.el-checkbox__label {
    color: $lan;
  }
  .useAddress .el-button+.el-button {
    border: 2px solid $lan;
  }
</style>
